(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/prolong-bottom-sheet.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/prolong-bottom-sheet.js');

'use strict';

const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect;
const BottomSheet = svs.ui.ReactBottomSheet.BottomSheet;
const _svs$numbergames$prol = svs.numbergames.prolong_game,
  ProlongContext = _svs$numbergames$prol.context.ProlongContext,
  _svs$numbergames$prol2 = _svs$numbergames$prol.components,
  DaysSelection = _svs$numbergames$prol2.DaysSelection,
  DurationSelection = _svs$numbergames$prol2.DurationSelection,
  GameDatesInfo = _svs$numbergames$prol2.GameDatesInfo,
  PayFooter = _svs$numbergames$prol2.PayFooter,
  handlePay = _svs$numbergames$prol.pay.handlePay;
const ProlongBottomSheet = _ref => {
  let behavior = _ref.behavior,
    headerTitle = _ref.headerTitle,
    isFixed = _ref.isFixed,
    isExpanded = _ref.isExpanded,
    onStateChange = _ref.onStateChange;
  const prolongContext = useContext(ProlongContext);
  const wasReturnedFromDeposit = prolongContext.wasReturnedFromDeposit,
    shouldResumePayment = prolongContext.shouldResumePayment,
    productName = prolongContext.wager.productName;
  useEffect(() => {
    if (shouldResumePayment) {
      handlePay(prolongContext, true);
    }
  }, [shouldResumePayment]);
  useEffect(() => {
    svs.components.analytics.trackEvent({
      category: 'My Gaming',
      action: 'prolong_activeDialog',
      opt_label: productName
    });
  }, []);
  if (shouldResumePayment && wasReturnedFromDeposit) {
    return null;
  }
  return React.createElement(BottomSheet, {
    behavior: behavior,
    className: "prolong-game-bottom-sheet",
    headerTitle: headerTitle,
    isFixed: isFixed,
    isExpanded: isExpanded,
    onStateChange: onStateChange,
    customer: "tur"
  }, React.createElement("div", {
    className: "padding-xs-h-1 padding-md-h-2"
  }, React.createElement(DaysSelection, null), React.createElement(DurationSelection, null), React.createElement(GameDatesInfo, null)), React.createElement(PayFooter, null));
};
setGlobal('svs.numbergames.prolong_game.components.ProlongBottomSheet', ProlongBottomSheet);

 })(window);